<template>
  <div class="card-update-page">
    <card title="Edit Page">
      <div :disabled="inProgress">

        <fieldset class="form-group">
          <label for="pageName">Page Name</label>
          <input
            id="pageName"
            type="text"
            class="form-control form-control-lg"
            v-model="page.name"
            placeholder="Page Name"
          />
        </fieldset>

        <fieldset class="form-group">
          <label for="pageType">Page Type</label>
          <select v-model="page.type" id="pageType" class="form-control">
            <option value="place">Place</option>
            <option value="video">Video</option>
          </select>
        </fieldset>

        <fieldset class="form-group" :dir="activeLanguage.rtl ? 'rtl' : 'ltr'">
          <label for="pageHeading">Label</label>
          <input
            id="pageHeading"
            type="text"
            class="form-control form-control-lg"
            v-model="page.heading[activeLanguage.code]"
            placeholder="Page Heading"
          />
        </fieldset>

        <fieldset class="form-group" >
          <label>Description</label>
          <ck-editor
            v-model="page.description[activeLanguage.code]"
            :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
            :key="activeLanguage.code"
            :language="activeLanguage.code"
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="qrUrl">QR Code URL</label>
          <input
            id="qrUrl"
            type="text"
            class="form-control form-control-lg"
            v-model="page.qrUrl"
            placeholder="https://domain.com/"
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="qrMessage">QR Code Message</label>
          <input
            id="qrMessage"
            type="text"
            class="form-control form-control-lg"
            v-model="page.qrMessage"
            placeholder="A brief description of where the QR code will take the user."
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="virtualTourUrl">Virtual Tour URL</label>
          <input
            id="virtualTourUrl"
            type="text"
            class="form-control form-control-lg"
            v-model="page.virtualTourUrl"
            placeholder="https://domain.com/"
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="virtualTourMessage">Virtual Tour Button Label</label>
          <input
            id="virtualTourMessage"
            type="text"
            class="form-control form-control-lg"
            v-model="page.virtualTourButtonLabel"
            placeholder=""
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="issuuEmbed">Issuu Embed Url</label>
          <input
            type="text"
            class="form-control form-control-lg"
            v-model="page.issuuEmbedUrl"
            placeholder=""
          />
        </fieldset>

        <fieldset class="form-group" >
          <label for="issuuEmbed">iFrames</label>
          <input-key-value-pairs
            class="form-control form-control-lg"
            key-label="label"
            value-label="url"
            v-model="page.iframes"
          ></input-key-value-pairs>
        </fieldset>

        <fieldset class="form-group" v-if="['place', 'video'].indexOf(page.type) !== -1">
          <label>Select Minimap Image</label>
          <input-asset v-model="page.minimapImage" defaultCategory="minimapImage"></input-asset>
        </fieldset>

        <fieldset class="form-group" v-if="['place', 'video'].indexOf(page.type) !== -1">
          <label>Select Background Image</label>
          <input-asset v-model="page.backgroundImage" defaultCategory="pageBackground"></input-asset>
        </fieldset>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CkEditor from '@/components/CKEditor'
import InputAsset from '@/components/InputAsset'
import InputKeyValuePairs from '@/components/InputKeyValuePairs'
import InfoBox from '@/components/InfoBox'

export default {
  name: 'card-update-page',

  components: {
    CkEditor,
    InputAsset,
    InputKeyValuePairs,
    InfoBox
  },

  props: {
    inProgress: Boolean
  },

  computed: {
    ...mapGetters([
      'activeLanguage',
      'page'
    ])
  }
}
</script>

<style lang="scss" scoped>
.card-update-page {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}
</style>
